import { Link } from "react-router-dom";
import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import ShareQR from "@/components/site/ShareQR";

export default function Footer({ settings }) {
  const email = settings?.contact_email || "hello@insidementalinjustice.com";
  const press = (settings?.press_mentions || []).filter((p) => p && (p.name || "").trim());
  const [sub, setSub] = useState("");
  const [busy, setBusy] = useState(false);
  const subscribe = async (e) => {
    e.preventDefault();
    if (!sub) return;
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter", { email: sub });
      toast.success(data.message || "Subscribed");
      setSub("");
    } catch { toast.error("Could not subscribe. Check your email and try again."); }
    finally { setBusy(false); }
  };
  return (
    <footer data-testid="site-footer" className="border-t border-imi-border bg-imi-bg">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-5">
            <img src="/imi-logo.jpg" alt="IMI" className="h-12 w-12 object-cover rounded-sm border border-imi-border" />
            <div className="font-serif text-imi-goldlight text-xl">Inside of Mental Injustice</div>
          </div>
          <p className="text-imi-text/50 text-sm leading-relaxed max-w-sm">
            Survivor-led media, production and advocacy. Built to move hearts, change policy, and protect lives.
          </p>
          <form onSubmit={subscribe} data-testid="newsletter-form" className="mt-7 max-w-sm">
            <div className="text-[11px] uppercase tracking-[0.25em] text-imi-gold mb-3">Join the movement</div>
            <div className="flex items-center border-b border-imi-border focus-within:border-imi-gold transition-colors">
              <input type="email" required value={sub} onChange={(e) => setSub(e.target.value)} data-testid="newsletter-email" placeholder="Your email"
                className="bg-transparent outline-none py-3 text-imi-text placeholder:text-imi-text/30 w-full text-sm" />
              <button type="submit" disabled={busy} data-testid="newsletter-submit" className="text-imi-gold text-xs uppercase tracking-[0.15em] hover:text-imi-goldlight transition-colors whitespace-nowrap pl-3">
                {busy ? "…" : "Subscribe"}
              </button>
            </div>
          </form>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.25em] text-imi-gold mb-5">Explore</div>
          <ul className="space-y-3 text-sm text-imi-text/60">
            <li><Link to="/videos" className="hover:text-imi-gold transition-colors">Films & Videos</Link></li>
            <li><Link to="/gallery" className="hover:text-imi-gold transition-colors">Gallery</Link></li>
            <li><Link to="/share" className="hover:text-imi-gold transition-colors">Share your story</Link></li>
            <li><a href="/#support" className="hover:text-imi-gold transition-colors">Support / Donate</a></li>
          </ul>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.25em] text-imi-gold mb-5">Connect</div>
          <a href={`mailto:${email}`} className="text-sm text-imi-text/80 hover:text-imi-gold transition-colors block mb-3">{email}</a>
          <p className="text-sm text-imi-text/50">insidementalinjustice.com</p>
          <Link to="/admin" data-testid="footer-admin-link" className="inline-block mt-6 text-[11px] uppercase tracking-[0.25em] text-imi-text/40 hover:text-imi-gold transition-colors">
            Admin
          </Link>
          <div className="mt-8 pt-8 border-t border-imi-border">
            <ShareQR variant="compact" />
          </div>
        </div>
      </div>
      <div className="border-t border-imi-border">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row justify-between gap-2 text-xs text-imi-text/40">
          <span>© {new Date().getFullYear()} Inside of Mental Injustice. All rights reserved.</span>
          <span>Survivor-led • Independent • Uncompromising</span>
        </div>
      </div>
    </footer>
  );
}
